import ParticipantCard from './ParticipantCard';
import { useLanguage } from '../../contexts/LanguageContext';

export default function ParticipantsList({ participants, onVote, voting = false, blurImages = false }) {
  const { t } = useLanguage();

  if (!participants || participants.length === 0) {
    return (
      <div className="flex justify-center items-center py-8 xs:py-12 px-4 xs:px-6 anim-fade-in">
        <p className="text-slate-500 text-base xs:text-lg">{t('participants.empty')}</p>
      </div>
    );
  }

  return (
    <div className="flex flex-nowrap justify-start gap-6 px-4 xs:px-6 overflow-x-auto pb-4 scrollbar-thin scrollbar-thumb-slate-300/80 scrollbar-track-transparent anim-fade-up" style={{ animationDelay: '80ms' }}>
      <div className="flex flex-wrap justify-center gap-x-4 xs:gap-x-6 gap-y-4 xs:gap-y-8 px-3 xs:px-6 w-full max-w-[980px] mx-auto anim-fade-up" style={{ animationDelay: '80ms' }}>
        {participants.map((participant) => (
          <div key={participant.id} className="flex justify-center m-4">
            <ParticipantCard 
              participant={participant} 
              onVote={onVote}
              disabled={voting}
              blurImage={blurImages}
            />
          </div>
        ))}
      </div>
    </div>
  );
}
